import styled from 'styled-components';

export const FormEducacaoContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;